import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {TopicDto} from "@/store/forum/types";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import SpriteUtils from "@/utils/sprite-utils";
import {IntegrationUtils} from "@/utils/integration-utils";

export class TopicActionsPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, editCallback: () => unknown, deleteCallback: () => unknown,
                pinCallback: (() => unknown)|undefined, topic: TopicDto | undefined) {
        super(scene, canvas, Tr('deystvija'));

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('viberite.deystvie'), 0, -125,
            '#ffe40e', 20, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        this.add([blockFirst]);

        if (topic) {

            SpriteUtils.scale(this.addCustomButton(-140, 150, Tr('edit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, editCallback), 0.8);

            SpriteUtils.scale(this.addCustomButton(0, 150, Tr('copy'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {
                IntegrationUtils.copyToClipboard('{{' + String(topic.id) + '||' + String(topic.title) + '}}');
                new FeedbackPanel(scene, Tr('copied'), undefined, true).show();
            }), 0.8);

            SpriteUtils.scale(this.addCustomButton(140, 150, Tr('delete'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, deleteCallback), 0.8);

            SpriteUtils.scale(this.addCustomButton(0, 0, topic.pinned? Tr('unpin.topic'):Tr('pin.topic'),
                Keys.UI_ART_BROWN_BUTTON, undefined, topic.pinned? Keys.FRM_PIN_WHITE : Keys.FRM_PIN_GREEN, pinCallback), 0.8);

        } else {

            this.addCustomButton(-100, 150, Tr('edit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, editCallback);

            this.addCustomButton(100, 150, Tr('delete'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, deleteCallback);

            this.addCustomButton(100, 150, Tr('delete'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, deleteCallback);

        }
    }

}
